// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1___c6ab06af58d3e8844b5","cls2":"News-cls2__cbbc7b0b40b2480dbe68 News-cls1___c6ab06af58d3e8844b5"};